import React from "react";
import { useNavigate } from "react-router-dom";
import { useProductPhotosContext } from "../../utils/Contexts/V2/ProductPhotosContext";
import PhotoUploaded from "../../assets/gifs/photo-upload.gif";

function PhotoUploadConfirmation() {
  const navigate = useNavigate();

  const { setShowUploadConfirmation } = useProductPhotosContext();

  return (
    <div className="relative w-full">
      <div className="relative -bottom-16  h-screen flex bg-blur" />
      <div className="relative bottom-0 flex flex-col justify-between items-center space-y-5 w-full h-[27rem] px-4 pt-[1.7rem] pb-6 bg-white rounded-t-2xl overflow-hidden">
        <div className="text-center flex flex-col space-y-4">
          <p className="text-base font-semibold">Success!</p>
          <p className="text-base font-normal">
            Your product photo has been uploaded.
          </p>
        </div>
        <img
          src={PhotoUploaded}
          alt="uploaded"
          className="w-[15rem h-[15rem]"
        />
        <div className="flex flex-col space-y-3 w-full">
          <button
            type="button"
            className="w-full  h-12 text-white text-base font-semibold rounded-xl bg-primary-50 thryve:text-base"
            onClick={() => {
              setShowUploadConfirmation(false);
              navigate("/");
            }}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

export default PhotoUploadConfirmation;
